
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Box } from '@mui/material';
import LoadingComponent from 'components/loading-component/loading-component';
import { useEffect, useRef } from 'react';
import { useAmplitude } from 'react-amplitude-hooks';
import { login } from 'utility/auth/auth';
import { getDefaultServerProps } from 'utility/node/defaultServerProps';
import { Route } from 'utility/routes';
import { addMessageWithGroup, SentryGroup } from 'utility/sentry';
const Login = () => {
    const { logEvent } = useAmplitude();
    const hasTriggeredLogin = useRef(false);
    useEffect(() => {
        if (hasTriggeredLogin.current) {
            return;
        }
        hasTriggeredLogin.current = true;
        login(logEvent, false).catch((e) => {
            addMessageWithGroup({
                message: e,
                group: SentryGroup.auth,
                tag: 'login',
                printToConsole: true,
                consoleMessage: e,
            });
        });
        // Dependency array needs to be empty to avoid Load Failed error in Safari and iOS Chrome
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return <LoadingComponent fullPage={true}/>;
};
Login.auth = false;
async function getServerSideProps(ctx) {
    const defaultServerProps = await getDefaultServerProps(ctx);
    const userOnboarded = ctx.req.cookies.user_onboarded;
    const agentCookie = ctx.req.cookies.agent;
    if (agentCookie) {
        ctx.res.setHeader('Set-Cookie', `agent=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT; HttpOnly`);
    }
    if (defaultServerProps.session && !userOnboarded) {
        return {
            redirect: {
                permanent: false,
                destination: Route.DASHBOARD,
            },
        };
    }
    return {
        props: {
            ...defaultServerProps,
        },
    };
}
export default Login;

    async function __Next_Translate__getServerSideProps__1a1a173322e__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/login/mitid',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a1a173322e__ as getServerSideProps }
  